import { Injectable } from '@angular/core';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from 'src/app/models/api-response.model';
import { IncidentNoteModel } from '../incident-note.model';

@Injectable({
  providedIn: 'root'
})
export class IncidentNoteService {
  private readonly resourceUrl = 'incident-notes';

  constructor(private api: ApiRequestService) {}

  create(
    note: IncidentNoteModel
  ): Observable<ApiResponseModel<IncidentNoteModel>> {
    return this.api.makeRequestObservable('post', 'v1/' + this.resourceUrl, note);
  }

  update(
    note: IncidentNoteModel
  ): Observable<ApiResponseModel<void>> {
    return this.api.makeRequestObservable(
      'put',
      'v1/' + this.resourceUrl + `/${note.id}`,
      note
    );
  }

  remove(ids: number[]): Observable<ApiResponseModel<void>> {
    return this.api.makeRequestObservable(
      'delete',
      'v1/' + this.resourceUrl + `/${ids.join(',')}`
    );
  }
}
